import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import css from 'styled-jsx/css'

import { contactPath } from '~/common/define/path'
import OpinionForm from '~/components/app/form/opinion/OpinionForm'
import SupportButton from '~/components/atoms/button/SupportButton'
import InternalLink from '~/components/atoms/link/InternalLink'
import SupplementText from '~/components/atoms/text/SupplementText'
import Segments, { SegmentSize } from '~/components/wrapper/section/Segments'
import FormButtonArea from '~/components/wrapper/form/FormButtonArea'
import LinkText from '~/components/atoms/text/LinkText'

interface Props {
  onClickClose(): void
}

const OpinionBlock = ({onClickClose}: Props) => {
  const {t} = useTranslation()
  const [sent, setSent] = useState<boolean>(false)

  const onClose = () => {
    onClickClose()
    setSent(false)
  }

  // component original styles
  const {className: bottomClass, styles: bottomStyle} = css.resolve`
    p { text-align: right; }
  `

  const {className: completedClass, styles: completedStyle} = css.resolve`
    p { padding: 40px; }
  `
  const {className: pClass, styles: pStyle} = css.resolve`
    p { margin-right: auto; color: black; }
  `

  return (
    <div>
      {!sent ?
        <Segments column size={SegmentSize.SMALL}>
          <p className={pClass}>{t('header:please_inform_improvement')}</p>
          <OpinionForm setRequested={() => setSent(true)}/>
          <p className={pClass}>
            <SupplementText>
              {t('header:service_improvement_message_1')}
              <br/>
              {t('header:service_improvement_message_2')}
            </SupplementText>
          </p>
          <p className={bottomClass}>
            <InternalLink link={contactPath()}>
              <LinkText>{t('header:contact')}</LinkText>
            </InternalLink>
          </p>
          {bottomStyle}
        </Segments>
        :
        <div className={completedClass}>
          <Segments column size={SegmentSize.SMALL}>
            <p className={pClass}>
              {t('header:service_improvement_complete_message_1')}<br/>
              {t('header:service_improvement_complete_message_2')}
            </p>
            <FormButtonArea>
              <InternalLink link={contactPath()}>
                <LinkText>{t('header:contact')}</LinkText>
              </InternalLink>
              <SupportButton onClick={() => onClose()}>{t('action.close')}</SupportButton>
            </FormButtonArea>
          </Segments>
        </div>
      }
      {pStyle}
      {completedStyle}
      <style jsx>{`
        div {
          width: 600px;
          background: white;
          border-radius: 6px;
          padding: 16px;
        }
      `}</style>
    </div>
  )
}

export default OpinionBlock